export const defaults = {
  workflowId: '',
  waitForCompletion: true,
  inputDataMode: 'acceptAll',
  inputMapping: {},
  inputJson: '{}',
};
